<template>
<div class="contener">
<el-main>
	<div class="content">
      <div class="main" v-if="edit">
		<img class="backImg"  src="../../assets/img/编组 4.png" />
		<div class="box">
		<div data-permissions="view:rpo" v-has>
		  <div class="smallbox" >
		  <img  class="img1"  src="../../assets/img/未标题-12.png" />
		   <div class="title">RPO</div>
		   <div class="title1">招聘流程外包管理系统</div>
	       <button class="btn"  @click="entryrpo">进入</button>
		  </div>
		  </div>
		  <div data-permissions="view:sousouguan" v-has >
		    <div class="smallbox" >
          <img  class="img2"  src="../../assets/img/未标题-13.png" />
          <div class="title">嗖嗖管</div>
          <div class="title1">一站式智能人力平台</div>
          <button class="btn" @click="entrysoso">进入</button>
		    </div>
      </div>
      <div data-permissions="view:shebaohd" v-has>
        <div class="smallbox"> 
        <img  class="img4"  src="../../assets/img/未标题-15.png" />
        <div class="title" style="margin-top: -45px;">社保后道</div>
        <div class="title1"></div>
        <button class="btn" @click="entrysosoSheBaoHouDao">进入</button>
      </div>
      </div>
      <div data-permissions="view:shebaoqd" v-has>
        <div class="smallbox"> 
           <img  class="img4"  src="../../assets/img/未标题-15.png" />
		      <div class="title" style="margin-top: -45px;">社保前道</div>
		      <div class="title1"></div>
	         <button class="btn" @click="entrysosoSheBaoQianDao">进入</button>
		     </div>
      </div>
      <!-- <div data-permissions="view:eem:project" v-has >
		    <div class="smallbox" >
          <img  class="img2"  src="../../assets/img/未标题-17.png" />
          <div class="title">嗖嗖用工</div>
          <div class="title1">一站式智能人力平台</div>
          <button class="btn" @click="entryssgNewAttend">进入</button>
		    </div>
      </div> -->
      
           <div>
		  <div  data-permissions="view:sousoupay" v-has >
        <div class="smallbox"> 
           <img  class="img4"  src="../../assets/img/未标题-15.png" />
		      <div class="title" style="margin-top: -45px;">嗖嗖发薪</div>
		      <div class="title1">一键算税，智能发薪</div>
	         <button class="btn" @click="entrysosoPay">进入</button>
		     </div>
        </div>	
        <div>
        </div>		  	  
         </div>
          <!-- <div data-permissions="view:bi" v-has >
		   <div class="smallbox" >
		   <img  class="img5"  src="../../assets/img/未标题-16.png" />
		   <div class="title">嗖嗖背调</div>
		   <div class="title1">智能背调平台</div>
	      <button  class="btn" @click="entryssgBacktone">进入</button>
		  </div>
		   </div>	 -->
		   <div data-permissions="view:sysset" v-has >
		   <div class="smallbox" >
		   <img  class="img3"  src="../../assets/img/未标题-14.png" />
		   <div class="title">系统设置</div>
		   <div class="title1">一站式智能人力平台</div>
	      <button  class="btn" @click="entrysystem">进入</button>
		  </div>
		   </div>		
        
		</div>
     	  
      </div>
	</div>
  </el-main>
</div>

</template>

<script>
export default {
  name: "entry",
  data() {
    return {
      edit: false,
      before: "before",
      after: "after",
    };
  },
  mounted() {
    this.load();
  },

  methods: {
    entryrpo() {
      let btnPermissionsStr = sessionStorage.getItem("btnPermissions");
      window.location.href = this.$axios.defaults.baseURL2 + "#/dataOverview";
      // if (btnPermissionsStr.indexOf("view:rporesume") > -1) {
      //   window.location.href = this.$axios.defaults.baseURL2 + "#/resume";
      // } else if (btnPermissionsStr.indexOf("view:rpoprojectmanage") > -1) {
      //   window.location.href =
      //     this.$axios.defaults.baseURL2 + "#/projectMangement/Project";
      // } else if (btnPermissionsStr.indexOf("view:rpocandidate") > -1) {
      //   window.location.href =
      //     this.$axios.defaults.baseURL2 + "#/candidate/fullResume";
      // } else if (btnPermissionsStr.indexOf("view:rpo:datareport") > -1) {
      //   //报表
      //   if (btnPermissionsStr.indexOf("view:rpo:projectstatistics") > -1) {
      //     window.location.href =
      //       this.$axios.defaults.baseURL2 + "#/dataReport/proPerformStatics";
      //   }
      // } else if (btnPermissionsStr.indexOf("view:rpo:systemset") > -1) {
      //   //公司设置-招聘品牌设置
      //   if (btnPermissionsStr.indexOf("view:rpo:companyset") > -1) {
      //     window.location.href =
      //       this.$axios.defaults.baseURL2 + "#/system/brandSet";
      //   } else if (btnPermissionsStr.indexOf("view:rpo:resumeset") > -1) {
      //     if (
      //       btnPermissionsStr.indexOf("view:rpo:customresumepartition") > -1
      //     ) {
      //       window.location.href =
      //         this.$axios.defaults.baseURL2 + "#/system/customResumeZone";
      //     } else if (
      //       btnPermissionsStr.indexOf("view:rpo:customresumepartitionset") > -1
      //     ) {
      //       window.location.href =
      //         this.$axios.defaults.baseURL2 + "#/system/resumeZoneSetting";
      //     } else if (
      //       btnPermissionsStr.indexOf("view:rpo:emailresumesynchronization") > -1
      //     ) {
      //       window.location.href =
      //         this.$axios.defaults.baseURL2 + "#/system/emailResumeSync";
      //     }
      //   }
      // }
    },
    load() {
      //  let btnPermissionsStr = sessionStorage.getItem("btnPermissions");
      //  if(!btnPermissionsStr) {
      let codes = "";
      this.$employAxios.get("/permission/getCodes").then((res) => {
        for (var i = 0; i < res.data.data.length; i++) {
          let vvv = "";
          codes += res.data.data[i] + ",";
          var str = codes.substring(0, codes.length - 1);
        }
        codes = str;
        sessionStorage.clear();
        sessionStorage.setItem("btnPermissions", codes);
        this.edit = true;
      });
      //    }
    },
    entrysoso() {
      this.$router.push({ path: "/ssgSplat" });
      localStorage.removeItem("filterForm");

    },
    entryssgNewAttend() {
      this.$router.push({ path: "/ssgNewAttend" });
    },
    entrysystem() {
      this.$router.push({ path: "/main/system/system/company" });
    },
    entryssgBacktone() {
      this.$router.push({ path: "/main/ssgBacktone" });
    },
    // 嗖嗖社保后道
    entrysosoSheBaoHouDao() {
      window.location.href =
        this.$axios.defaults.baseURL7 + `#/mainAfter/myProject`;
    },
    // 前道
    entrysosoSheBaoQianDao() {
      window.location.href =
        this.$axios.defaults.baseURL7 + `#/mainBefore/myProject`;
    },
    entrysosoPay() {
      let btnPermissionsStr = sessionStorage.getItem("btnPermissions");
      if (btnPermissionsStr.indexOf("view:ssp:project") > -1) {
        window.location.href =
          this.$axios.defaults.baseURL4 + "#/ssgPay/payroll";
      } else if (btnPermissionsStr.indexOf("view:ssp:taxmaintenance") > -1) {
        window.location.href =
          this.$axios.defaults.baseURL4 + "#/ssgPay/deduction";
      } else if (btnPermissionsStr.indexOf("view:ssp:taxpaycomp") > -1) {
        window.location.href =
          this.$axios.defaults.baseURL4 + "#/ssgPay/compared";
      }else if(btnPermissionsStr.indexOf("view:ssp:socialcalc") > -1) {
        window.location.href =
          this.$axios.defaults.baseURL4 + "#/ssgPay/calculator";
      } else if(btnPermissionsStr.indexOf("view:ssp:payrollrecords") > -1) {
        window.location.href =
          this.$axios.defaults.baseURL4 + "#/ssgPay/record";
      }else if(btnPermissionsStr.indexOf("view:ssp:salary") > -1) {
        window.location.href =
          this.$axios.defaults.baseURL4 + "#/ssgPay/salary";
      }

    },
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  height: 820px;
}
.main {
  z-index: 1;
  width: 100%;
  height: 440px;
  text-align: center;
  background: linear-gradient(
    133deg,
    rgba(98, 103, 235, 1) 0%,
    rgba(112, 94, 206, 1) 100%
  );
  .backImg {
    margin: 40px auto;
    // position: relative;
  }
  @media screen and (min-width: 1620px) {
    .contener /deep/ .el-main {
      // max-height: 700px;
      overflow: auto;
      padding: 0;
    }
  }

  @media screen and (max-width: 1620px) {
    .contener /deep/ .el-main {
      max-height: 700px;
      overflow: auto;
      padding: 0;
    }
  }

  .box {
    display: flex;
    justify-content: center;
    margin-top: -360px;
    transform: scale(0.7, 0.7);
    .smallbox {
      margin-left: 15px;
      width: 270px;
      height: 460px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 10px 14px 0px rgba(102, 105, 227, 0.33);
      border-radius: 6px;
      margin-bottom: 145px;
      .img1 {
        margin: 66px auto;
      }
      .img2 {
        margin: 70px auto;
      }
      .img3 {
        margin: 77px auto;
      }
      .img4 {
        margin: 77px auto;
      }
      .img5 {
        margin: 67px auto;
      }
      .img7 {
        margin: 67px auto;
      }
      .title {
        font-size: 24px;
        font-weight: bold;
        color: rgba(48, 49, 64, 1);
        margin: 0 auto;
        margin-top: -20px;
      }
      .title1 {
        font-size: 12px;
        font-weight: 400;
        color: rgba(48, 49, 64, 1);
      }
      .btn {
        width: 201px;
        height: 34px;
        border-radius: 4px;
        border: 1px solid rgba(102, 105, 227, 1);
        margin: 79px auto;
        color: #6669e3;
      }
    }
    .smallbox:hover {
      margin-top: -10px;
      width: 270px;
      height: 480px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 10px 14px 0px rgba(102, 105, 227, 0.4);
      border-radius: 6px;
      .btn {
        width: 201px;
        height: 34px;
        background: linear-gradient(
          138deg,
          rgba(95, 105, 241, 1) 0%,
          rgba(115, 92, 201, 1) 100%
        );
        border-radius: 4px;
        color: #ffffff;
        cursor: pointer;
      }
    }
    @media screen and (max-width: 1366px) {
      .smallbox {
        width: 223px;
      }
    }
    @media screen and (min-width: 1920px) {
      .smallbox {
        width: 270px;
      }
    }
    @media screen and (max-width: 1366px) {
      .smallbox:hover {
        width: 223px;
      }
    }
    @media screen and (min-width: 1920px) {
      .smallbox:hover {
        width: 270px;
      }
    }
  }
}
</style>